import GameApp from "../../../index";
import Location from "@/scenes/location";
import { Figure } from "@/actors/figure";

export class OutfitActionsHandler {
  static async handle(data) {
    const scene = GameApp.game.currentScene as Location;
    if (!scene) return;

    const user = scene.figureManager.getFigureById(data.player.id) as any;
    if (user) {
      const figure: Figure = user.figure;
      figure.setLook(data.player.look);
      figure.showDustCloud();
    }
  }
}
